// Single tunable config for the show: phase timings, assist ramp, unlock rules, voice/preload.
export const FEELINGS = ['curiosity', 'fear', 'trust', 'joy', 'grief', 'unity'];

export const SHOW_CONFIG = {
  phases: {
    openingMinMs: 8000,
    openingMaxMs: 16000,
    introMinMs: 4000,
    introMaxMs: 14000,
    revealMinMs: 6500,
    revealMaxMs: 15000,
    finaleMinMs: 9000,
    finaleMaxMs: 22000,
  },
  assist: { hintAtMs: [15000, 30000, 45000], easeAtMs: 40000, easeFactor: 0.75, hostPromptAtMs: 60000 },
  keyArmAt: 0.7,
  keyDisarmAt: 0.5,
  reactions: { minGapMs: 8000, staleMs: 4000, strokeQuietMs: 3000 },
  voice: {
    priorities: { reveal: 4, opening: 3, intro: 3, finale: 3, hint: 2, reaction: 1 },
    onDemandTimeoutMs: 2500,
    textOnlyMsPerChar: 55,
    textOnlyMinMs: 2500,
    staleMs: 4000,
  },
  preload: { textBatchConcurrency: 2, voiceConcurrency: 4, voiceTimeoutMs: 15000, scriptTimeoutMs: 45000 },
  resetConfirmMs: 3000,
  chapters: {
    // Tutorial: gentle strokes with low agitation; unlocks at 100% (~8 strokes).
    curiosity: { strokesNeeded: 8, maxAgitation: 0.35, wrongMoodStrokeFactor: 0.3, agitationDecayAbove: 0.5, decayPerS: 0.03 },
    // Agitation/rapid hits fill; key = N solid pulses within window.
    fear: { perPulse: 0.09, agitationRatePerS: 0.12, calmBelow: 0.2, decayPerS: 0.04, keyPulses: 5, keyWindowMs: 4000 },
    // Calm stroking while agitation falls; key = 3 evenly spaced solid pulses ("heartbeat").
    trust: { perStroke: 0.12, calmRatePerS: 0.04, maxAgitation: 0.45, decayAbove: 0.65, decayPerS: 0.05, keyPulses: 3, minGapMs: 600, maxGapMs: 2000, spacingTolerance: 0.35, easedTolerance: 0.45, easedGapScale: 1.25 },
    // Mixed play (strokes/brushes + pulses, high activity); key = STROKE→PULSE→STROKE→PULSE.
    // Forgiving: a ~0.5s gentle burst (BRUSH) counts as a stroke, pulses above minPulseConfidence count,
    // progress is kept unless the gap between steps exceeds stepGapMs.
    joy: { mixWindowMs: 6000, mixBonusWindowMs: 5000, minActivity: 0.25, ratePerS: 0.12, perMixed: 0.06, decayBelowActivity: 0.15, decayPerS: 0.02, keySequence: 4, easedSequence: 3, keyWindowMs: 16000, stepGapMs: 7000, minPulseConfidence: 0.3 },
    // Stillness only; touches knock it down partially; unlocks at 100%.
    grief: { fillSeconds: 10, stillAfterS: 1, touchDecayPerS: 0.1, pulseKnock: 0.5, strokeKnock: 0.75 },
    // All hands (sustained activity) → release (stillness) → one solid knock.
    unity: { activityMin: 0.5, easedActivityFactor: 0.8, sustainSeconds: 5, inactiveDecayPerS: 0.05, releaseSeconds: 3, stage1At: 0.7, stage2At: 0.85 },
  },
  keyLabels: {
    curiosity: 'GENTLE CONTACT',
    fear: 'FLURRY · 5 SOLID PULSES / 4s',
    trust: 'HEARTBEAT · 3 EVEN PULSES',
    joy: 'ALTERNATION · S P S P',
    grief: 'ABSENCE',
    unity: 'CONVERGE · RELEASE · KNOCK',
  },
};

// The preloaded show script (ids mirror backend prompts.SCRIPT_PLAN).
export const SCRIPT_PLAN = [
  { id: 'opening', group: 0 },
  ...FEELINGS.flatMap((f, i) => [
    ...['intro', 'hint1', 'hint2', 'hint3', 'reveal', 'reaction_touch', 'reaction_hit'].map((k) => ({ id: `${f}.${k}`, group: i })),
  ]),
  { id: 'finale', group: 5 },
];
